import * as yup from 'yup'
import dayjs, { Dayjs } from 'dayjs'

// `.test()` rather than `.required()`/`oneOf`: Formik turns '' into undefined before validating,
// and the date field holds `null` while empty, so presence is checked inside the test itself.
export const reconciliationFormValidator = yup.object({
  partnerId: yup.string().test('required', 'Choose a partner', (value) => {
    return (value ?? '').trim().length > 0
  }),
  startDate: yup
    .mixed<Dayjs>()
    .nullable()
    .test('past-date', 'Choose a start date up to today', (value) => {
      return Boolean(value && value.isValid() && !value.isAfter(dayjs(), 'day'))
    }),
})
